{
  "version": 1,
  "asset_id": "d2d2d52b-3164-4e8d-975f-edf080cde632",
  "project_id": "81e5f51e-81a3-47ad-9e0d-7249ca4c0a70",
  "url": "/__l5e/assets-v1/d2d2d52b-3164-4e8d-975f-edf080cde632/paysafecard.svg",
  "r2_key": "a/v1/81e5f51e-81a3-47ad-9e0d-7249ca4c0a70/d2d2d52b-3164-4e8d-975f-edf080cde632/paysafecard.svg",
  "original_filename": "paysafecard.svg",
  "size": 13272,
  "content_type": "image/svg+xml",
  "created_at": "2026-08-30T15:11:58Z"
}
